export type MST_CLC_TYP = {
    /** 演算種別IDを取得または設定します。 */
    MCLC_TYP_ID: number;
    /** 演算名称を取得または設定します。 */
    MCLC_TYP_NAME: string;
    /** 表示順を取得または設定します。 */
    SORT_NO: number;

    /** リスト編集フラグ */
    isEdit: boolean;
}

/**
 * デバイス名称一覧を取得
 * @returns 
 */
export const GetMstClcTyp = (): Promise<MST_CLC_TYP[]> => {
    return new Promise((resolve, reject) => {
        fetch("api/MstClcTyp/")
            .then((res) => {
                if (!res.ok) {
                    console.error(res);
                    let message = `データが見つかりませんでした status:${res.status}`;
                    reject(message);
                }
                else {
                    return res.json();
                }
            })
            .then((result: MST_CLC_TYP[]) => {
                console.debug(["GetMstClcTyp - ok ret ", result]);
                if (MstClcTypListListValidate(result)) {
                    result.forEach((dev) => {

                    });
                    resolve(result);
                }
                else {
                    reject('Invalidate response');
                }
            })
            .catch((error) => {
                console.error(error);
                reject(error);
            })
    })
};

/**
 * グループ一覧取得データ検証
 * @param data 
 * @returns 
 */
const MstClcTypListListValidate = (data: MST_CLC_TYP[]): boolean => {
    if (data == undefined) {
        console.debug(`MstClcTypListList NG `);
        return false;
    }
    console.debug(`MstClcTypListList OK `);
    return true;
};